import styled from 'styled-components';

const FullHeightFlex = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`;

export default FullHeightFlex;
